export const MAX_DECIMAL_SCALE = 4;

/**
 * Checks if a factor should be applied (valid positive number, not 0 or 1).
 */
export const shouldApplyFactor = (factor: unknown): factor is number =>
  typeof factor === 'number' && factor > 0 && factor !== 1;

/**
 * Calculates precision for rounding based on factor magnitude.
 * Returns MAX_DECIMAL_SCALE for invalid factors to prevent NaN.
 */
export const getPrecision = (factor: number): number => {
  // Guard against invalid factors (negative, zero, or non-finite)
  if (!Number.isFinite(factor) || factor <= 0) {
    return MAX_DECIMAL_SCALE;
  }

  if (factor > 1) {
    return MAX_DECIMAL_SCALE + Math.ceil(Math.log10(factor));
  }
  if (factor < 1) {
    return MAX_DECIMAL_SCALE + Math.ceil(Math.log10(1 / factor));
  }
  return MAX_DECIMAL_SCALE;
};

/**
 * Rounds a value to the specified number of decimal places.
 */
export const roundTo = (value: number, precision: number): number =>
  Math.round(value * 10 ** precision) / 10 ** precision;
